import React from "react";

export default function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="sticky top-14 z-20 backdrop-blur-xl bg-background/80 border-b border-border">
      <div className="px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          {overline && <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-bold mb-2">{overline}</div>}
          <h1 className="font-display text-3xl lg:text-4xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <div className="text-muted-foreground mt-1 text-sm">{subtitle}</div>}
        </div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
    </div>
  );
}
